export default "__VITE_ASSET__LTFDrehY__"